import React, {Component} from "react";
import {connect} from "react-redux";
import {SET_TICKET_LIST_RELOAD} from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import TumbnailImg from "./TumbnailImg";
import DisplayImage from "./DisplayImage";
import ErrorMessage from "../CommonComponents/ErrorMessage";
import SuccessMessage from "../CommonComponents/SuccessMessage";

import UserDetails from "../UserDetails/UserDetails";
import attactment from "../../svg/additional.svg";

import api from "../../api/api";

class NewReportTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMessage: {
                title: "New Support Ticket",
                description: "Write a new ticket",
                backIcon: false,
                moreOptionhidden: true,
                searchOptionHidden: true
            },
            submitBtnDisable: false,
            imgFiles: [],
            displayImage: false,
            imageNo: 0,
            fileToDisplay: null,
            displayErrorPopup: false,
            displaySuccessPopup: false,
            reportedName: "Playo User",
            reportedId: ""
        };
    }

    /**
     * this is for history or goback
     */
    goBack = () => {
        if (!this.state.displayImage) {
            window.open("/faqclose", "_self");
        } else {
            this.setState({
                displayImage: false
            });
        }
    };

    showSuccess = () => {
        this.setState({
            displaySuccessPopup: true
        });
    };

    onEnableSubmitBtn = () => {
        if (document.getElementById("ticketDesc").value.trim().length > 0) {
            this.setState({
                submitBtnDisable: false
            });
        } else {
            this.setState({
                submitBtnDisable: true
            });
        }
    };

    fileUploadClick = () => {
        document.getElementById("fileUpload").click();
    };

    getFileList = event => {
        if (event.target.files.length > 0) {
            this.setState({
                imgFiles: [...this.state.imgFiles, event.target.files[0]]
            });
        }
        document.getElementById("fileUpload").files = null;
    };

    onSubmitBtnClick = () => {
        const {
            userId,
            email,
            fName,
            name,
            mobile,
            city,
            countryCode,
            userIdv2
        } = this.props;
        const playoId = userIdv2 || userId;
        api.displayMainLoader();
        this.setState({
            submitBtnDisable: true
        });
        let uploadFilesId = [];

        let dataToSend = {
            title: `Delete Account: ${name}`,
            description: document.getElementById("ticketDesc").value,
            imageArray: uploadFilesId
        };
        api
            .createNewTicket(
                dataToSend,
                playoId,
                email,
                name,
                mobile,
                city,
                countryCode,
                null,
                true
            )
            .then(data => {
                this.setState({
                    submitBtnDisable: false
                });
                this.props.ticketUpdated();
                api.displayHideLoader();
                this.showSuccess();
            })
            .catch(error => {
                this.setState({
                    displayErrorPopup: true
                });
                api.displayHideLoader();
            });
    };

    onTumbnailClick = no => {
        --no;
        this.setState({
            displayImage: true,
            imageNo: no,
            fileToDisplay: this.state.imgFiles[no]
        });
    };

    deleteOption = no => {
        this.setState({
            displayImage: false,
            imgFiles: this.state.imgFiles.splice(no, -1)
        });
    };

    errorCloseCLick = () => {
        this.setState({
            displayErrorPopup: false
        });
    };

    componentDidMount() {
        api.displayHideLoader();
    }

    render() {
        const {fName, email} = this.props;
        let i = 0;
        const headerObj = {
            title: "Delete Account",
            backIcon: false,
            moreOptionhidden: true,
            searchOptionHidden: true
        };
        return fName && email ? (
            <div>
                {this.state.displayImage ? (
                    <DisplayImage
                        deleteOption={this.deleteOption.bind(this)}
                        no={this.state.imageNo}
                        image={this.state.fileToDisplay}
                        displayDeleteBtn={true}
                        back={this.goBack.bind(this)}
                    />
                ) : (
                    ""
                )}
                {this.state.displayErrorPopup ? (
                    <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)}/>
                ) : null}
                {this.state.displaySuccessPopup ? (
                    <SuccessMessage
                        message="We have recieved your request"
                        onCloseClick={this.goBack}
                    />
                ) : null}

                <HelpAndSupportHeader
                    displayMessage={headerObj}
                    back={this.goBack.bind(this)}
                />
                <div className="body-container">
                    {/* <div className="ticket-box-container">
            <div className="ticket-box">
              <div className="ticket-box-title">REASON</div>
              <input
                type="text"
                id="ticketTitle"
                className="ticket-box-input"
                placeholder="Give your report a title"
                maxLength="64"
                style={{ paddingLeft: 0 }}
                onChange={this.onEnableSubmitBtn.bind(this)}
              />
            </div>
          </div> */}
                    {/* <div className="article-body">If you delete the account, you won’t be able to reactivate it later.</div> */}
                    <div className="ticket-box-container" style={{marginTop: "25px"}}>
                        <div className="ticket-box">
                            <div className="ticket-box-title">DESCRIPTION</div>
                            <textarea
                                id="ticketDesc"
                                className="ticket-description-textarea"
                                placeholder="Describe the incident"
                                maxLength="512"
                                style={{paddingLeft: 0}}
                                defaultValue="Please delete my playo account."
                                onChange={this.onEnableSubmitBtn.bind(this)}
                            />
                        </div>
                    </div>
                </div>
                <div className="submit-btn-container">
                    <input
                        type="button"
                        className="submit-btn"
                        disabled={this.state.submitBtnDisable}
                        onClick={this.onSubmitBtnClick.bind(this)}
                        value="Request Account Deletion"
                    />
                </div>
            </div>
        ) : (
            <UserDetails/>
        );
    }
}

const mapStateToProps = (
    {
        userId,
        email,
        name,
        fName,
        mobile,
        countryCode,
        city,
        userIdv2
    }) => ({
        userId,
        email,
        name,
        fName,
        mobile,
        city,
        countryCode,
        userIdv2
    }
);

const mapDispatchToProps = dispatch => {
    return {
        ticketUpdated: () => {
            dispatch({
                type: SET_TICKET_LIST_RELOAD,
                payload: true
            });
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewReportTicket);



// WEBPACK FOOTER //
// ./src/components/Tickets/NewDeleteTicket.js